var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeadlockLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1 9A8.1 8.1 0 11.9 9a8.1 8.1 0 0116.2 0z",
    fill: "#CDDCFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1 9.124H.9v-.248h16.2v.248z",
    fill: "#0D0D28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.124.9v16.2h-.248V.9h.248z",
    fill: "#0D0D28"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.194 4.019l9.795 9.794-.176.176L4.02 4.194l.175-.175z",
    fill: "#0D0D28"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.989 4.194L4.194 13.99l-.175-.176 9.794-9.794.176.175z",
    fill: "#0D0D28"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 9l2.913-2.066c.91-.538 2.643-1.051 4.153 0 .632.439 1.219.838 1.709 1.17.617.42 1.08.735 1.287.896H4zm0 0l2.913 2.066c.91.537 2.643 1.051 4.153 0 .632-.439 1.219-.838 1.709-1.17.617-.42 1.08-.735 1.287-.896H4z",
    fill: "#0D0D28"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.066 9a2.066 2.066 0 11-4.132 0 2.066 2.066 0 014.132 0z",
    fill: "#CDDCFE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.157 9a1.157 1.157 0 11-2.314 0 1.157 1.157 0 012.314 0z",
    fill: "#0D0D28"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 15.819A6.819 6.819 0 109 2.18 6.819 6.819 0 009 15.82zm0 .248A7.067 7.067 0 109 1.933a7.067 7.067 0 000 14.134z",
    fill: "#0D0D28"
  })));
}
export default __webpack_public_path__ + "static/svg/deadlock-logo.svg";
export { SvgDeadlockLogo as ReactComponent };